module.exports = __webpack_public_path__ + "static/media/CLA_CSV_7.aa446df9.svg";